import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Control, LocalForm } from 'react-redux-form';

import { customerInfos as customerInfosDuck, customers as customersDuck, flashMessages } from 'ducks';
import { duckify, singleDuck } from 'utils/duckify';
import FlashRoot from 'components/FlashMessage/FlashRoot';

import './styles/Reindex.scss';

const Reindex = ({
  customer,
  customers,
  environment,
  showFlash
}) => {
  const initialState = {
    customer_set: 'selected',
    customer_ids: [customer.id]
  };

  const onSubmit = (reindex) => {
    const token = $('meta[name="csrf-token"]').attr('content');
    fetch('/api/reindex', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json',  'X-CSRF-Token': token},
      body: JSON.stringify({ reindex })
    })
      .then((response) => (response.ok ? response : response.json()))
      .then((response) => {
        if (!response.ok) {
          throw Error(response.error);
        }
      })
      .then(() => showFlash({ message: 'Reindex started.' }))
      .catch((e) => showFlash({ type: 'danger', message: e.message }));
  };

  return customers.ready && (
    <div className='reindex'>
      <FlashRoot />
      <h2>Reindex</h2>

      <LocalForm className='form-horizontal' initialState={initialState} onSubmit={onSubmit}>
        <div className='mb-3'>
          <div className='form-check'>
            <Control.radio
              model='.customer_set'
              id='customer_set_selected'
              value='selected'
              className='form-check-input'
            />
            <label className='form-check-label' htmlFor='customer_set_selected'>Selected customers</label>
          </div>

          <Control.select
            multi
            component={Select}
            model='.customer_ids'
            options={customers.map((c) => ({
              value: c.id,
              label: c.subdomain
            }))}
            mapProps={{ onChange: (props) => (selected) => props.onChange(selected.map((s) => s.value)) }}
          />
        </div>

        <div className='mb-3'>
          <div className='form-check'>
            <Control.radio
              model='.customer_set'
              id='customer_set_all'
              disabled={environment === 'production'}
              value='all'
              className='form-check-input'
            />
            <label className='form-check-label' htmlFor='customer_set_all'>
              <span className={environment === 'production' ? 'reindex-disabled' : ''}>
                All&nbsp;
                {customers.length}
                &nbsp;customers
              </span>
              {
                environment === 'production' && (
                  <span className='helper-text reindex-unavailable'>
                    (Not available in production)
                  </span>
                )
              }
            </label>
          </div>
        </div>

        <input type='submit' className='btn btn-danger' value='Submit' />
      </LocalForm>
    </div>
  );
};

const customerShape = PropTypes.shape({ id: PropTypes.string });

Reindex.propTypes = {
  customer: customerShape,
  customers: PropTypes.arrayOf(customerShape),
  environment: PropTypes.string,
  showFlash: PropTypes.func
};

Reindex.defaultProps = {
  customer: {},
  customers: [],
  environment: 'development',
  showFlash: () => false
};

const mapDucksToProps = () => ({
  customer: singleDuck(customersDuck, 'current'),
  customers: customerInfosDuck
});

const mapStateToProps = (state) => ({
  environment: state.appConfig.railsEnv
});

const mapDispatchToProps = (dispatch) => ({
  showFlash: (props) => dispatch(flashMessages.actions.show(props))
});

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(Reindex);
